import "../CSS/ticketSalon.css";
import React, { useRef, useEffect, useState, Fragment } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useLocation } from "react-router-dom";
import axios from "axios";

function TicketSalon(props) {
  const location = useLocation();

  const {
    salon,
    nombre,
    fecha,
    nombreParticipante,
    asientos,
    id,
    idTicket,
    fechaCompra,
    comidas,
    nroTicket,
    asientosString,
    handleConvert,
	tipoEvento
  } = props;
  const [url, setUrl] = useState("");
  const [tablesSeats, setTablesSeats] = useState([]);
  const [shortUrl, setShortUrl] = useState("");

  const handleShortenUrl = async () => {
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${encodeURIComponent(
          window.location.href
        )}`
      );
      //console.log("link corto " + response.data.replace("https://", ''));
      setShortUrl(response.data.replace("https://", ""));
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const qrcode = (
    <QRCodeCanvas
      style={{ marginTop: "10px" }}
      id="qrCode"
      value={`${shortUrl}`}
      size={100}
      bgColor={"#ffffff"}
      level={"H"}
    />
  );

  useEffect(() => {
    handleShortenUrl();
    //console.log("comidas" + comidas+"a ver");
  }, []);
  useEffect(() => {
    handleConvert();
  }, [shortUrl]);
  return (
    <div className="ts-cardWrap">
      <div className="ts-card ts-cardLeft">
        <div className="ts-cabecera">
          <img className="logo" src={require("../img/logo_cip.png")} />
          <div>
            <h1 className="ts-titulo-cabecera">
              <span>COLEGIOS DE INGENIEROS DEL PERU</span>
              <br />
              <span>CONSEJO DEPARTAMENTAL AREQUIPA</span>
            </h1>
            <h1 className="ts-numero-ti">
              <span>Ticket Nro: {nroTicket}</span>
            </h1>
          </div>
        </div>

        <div className="ts-title">
          <h2>{nombre}</h2>
          <span>Evento</span>
        </div>
        <div className="ts-title">
          <h2>{salon}</h2>
          <span>Lugar</span>
        </div>
        <div className="ts-nameTicket">
          <h2>{nombreParticipante}</h2>
          <span>Nombre Del Participante</span>
        </div>
        { tipoEvento == "Pago (con comida)"? (
          <div className="ts-nameTicket">
            <h2>{comidas}</h2>
            <span>Comida(s)</span>
          </div>
        ) : null}

        <div className="ts-nameTicket">
          <h2>{fecha}</h2>
          <span>Dia y hora del evento</span>
        </div>
      </div>
      <div className="ts-card cardRight">
        <div className="ts-card-eye">
          <h1 className="ts-fecha-compra">
            <span>{fechaCompra.split(",")[0]}</span>
            <br />
            <span className="ts-numero-ticket">Ticket Nro: {nroTicket}</span>
            <br />
          </h1>
        </div>
        <br></br>

        <div className="ts-card-eye">
          <div>{qrcode}</div>
        </div>
        <div className="ts-number">
          <h4 className="ts-numberAsientos">
            <span>
              {asientos.split(",").length} Asiento(s)<br></br>{" "}
              <pre style={{ fontFamily: "sans-serif" }}>{asientosString}</pre>
            </span>

            <br></br>
          </h4>
        </div>
      </div>
    </div>
  );
}

export default TicketSalon;
